<template>
  <gjw-dialog
    :title="title"
    :show-dialog="dialogVisible"
    :config="{ showFooter, width: '450px' }"
    @close="closeDialog"
    @confirm="confirmDialog">
    <div class="link-container">
      <div>
        <div class="row-item">
          <label style="margin-right: 10px;">
            <span style="margin-right: 3px;">权限</span>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                可使用：仅可查看及下载、使用，不可修改云端文件内容（例如：上传、更新、重命名、移动等）
                <br/>
                可编辑：除修改权限外不限制操作
              </div>
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            <span>：</span>
          </label>
          <el-radio-group v-model="selectRadio">
            <el-radio label="USABLE">可使用</el-radio>
            <el-radio label="EDITABLE">可编辑</el-radio>
          </el-radio-group>
        </div>
        <div class="row-item" v-if="isNeedInvitationLink">
          <span>链接有效期：24小时</span>
        </div>
      </div>
      <div v-if="isNeedInvitationLink">
        <el-button type="primary" @click="getInvitationLink">复制邀请链接</el-button>
      </div>
    </div>
  </gjw-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getInvitationLinkErrorCodeMap, modifyErrorCodeMap } from '@/views/member/errorCodeMap'
export default {
  data() {
    return {
      selectRadio: 'USABLE',
      spaceId: this.$route.params.spaceId,
      permissionParmes: {}
    }
  },
  props: {
    title: {
      type: String,
      default: '标题'
    },
    dialogVisible: {
      type: Boolean
    },
    isNeedInvitationLink: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
  },
  methods: {
    setparams(object_id, object_type) {
      this.permissionParmes = {
        permission_type: this.selectRadio,
        object_id,
        object_type
      }
    },
    async getInvitationLink() {
      let data
      try {
        data = await this.$api.member.getInvitationLink(this.spaceId, this.selectRadio)
      } catch (err) {
        this.$matchError(err.code, getInvitationLinkErrorCodeMap, '复制失败')
      }
      const linkInfoText = `${data?.inviterName}邀请您加入${data?.spaceName}，加入链接：${data?.invitationLink}，有效期至${this.$fmtTime(data?.expirationTime, 'YYYY-MM-DD HH:mm:ss')}，请尽快点击链接接受邀请~`
      try {
        await navigator.clipboard.writeText(linkInfoText)
      } catch (err) {
        if (err.name === 'NotAllowedError') {
          const res = await this.$desktopClient.ClipboardSetText(linkInfoText)
          if (res.code !== 'success') return
        }
      }
      if (data) {
        this.$message.success('已复制到剪贴板')
        this.$tracks({ event: 'inviteMember', params: { g_c_space_id: this.spaceId }})
        this.closeDialog()
      }
    },
    closeDialog() {
      this.$emit('close')
    },
    async confirmDialog() {
      try {
        const data = await this.$api.member.modifyPermission(this.spaceId, this.user.id, this.permissionParmes)
        if (data) {
          this.$message.success('设置成功')
          this.$emit('success')
          this.closeDialog()
        }
      } catch (err) {
        this.$matchError(err.code, modifyErrorCodeMap, '设置失败')
      } finally {
        this.closeDialog()
      }
    }
  }
}
</script>

<style scoped lang="less">
.link-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-item {
    padding: 10px 0;
  }
}
</style>
